import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=083a0a97"
import script from "./arrow.vue?vue&type=script&lang=js"
export * from "./arrow.vue?vue&type=script&lang=js"
import style0 from "./arrow.vue?vue&type=style&index=0&id=083a0a97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports